import { CountrySelectorValue } from '@headless-workspace/core-domain';
import { PropsWithLocale } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';
import { CountrySwitcher, LanguageSwitcher } from '../../../../../src';

export type HeaderSwitcherProps = PropsWithLocale & {
    countrySelector?: CountrySelectorValue;
    hostUrl: string | null;
};

export const HeaderSwitcher: Component<HeaderSwitcherProps> = ({ countrySelector, hostUrl, locale }) => {
    if (countrySelector) {
        return (
            <CountrySwitcher
                className={'p-0.5 hidden desktop:flex'}
                countrySelector={countrySelector}
                displayType={'header'}
                hostUrl={hostUrl}
                locale={locale}
            />
        );
    }

    return <LanguageSwitcher className={'p-0.5 hidden desktop:flex'} displayType={'header'} hostUrl={hostUrl} />;
};
